// Login dialog component for the library page

import React from 'react';
import AuthDialogFlow from '@/components/auth/AuthDialogFlow';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import { analyticsService } from '@/services/analyticsService';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const LoginDialog: React.FC<LibraryDialogOutletProps> = ({
  dialog,
  setDialog,
  authStep,
  setAuthStep,
}) => {
  return (
    <Dialog
      open={dialog === 'login'}
      onOpenChange={(nextOpen) => setDialog(nextOpen ? 'login' : null)}
    >
      <DialogContent
        className="max-w-lg border-none bg-transparent p-0 shadow-none ring-0"
        showCloseButton={false}
      >
        <DialogTitle className="sr-only">Login</DialogTitle>
        <DialogDescription className="sr-only">
          Sign in to your Airhead Games account.
        </DialogDescription>
        <AuthDialogFlow
          step={authStep}
          onStepChange={setAuthStep}
          onWelcomeContinue={() => {
            analyticsService.trackButtonClick("I'm ready", {
              link_location: 'library_login_success',
            });
            setDialog(null);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default LoginDialog;
